import { KeyValueModel } from "model";
import { EnumFiltroBloqueioCliente } from "model/enums/enum-filtro-bloqueio-cliente";

export const BloqueioClienteFiltroMock: KeyValueModel[] = [
    new KeyValueModel(EnumFiltroBloqueioCliente.Todos, 'Todos'),
    new KeyValueModel(EnumFiltroBloqueioCliente.NaoBloqueado, 'Não bloqueados'),
    new KeyValueModel(EnumFiltroBloqueioCliente.Bloqueado, 'Bloqueados'),
]
